const getDisclaimerHtml = (disclaimer) => {
  if (!disclaimer) return "";

  if (typeof disclaimer === "object") {
    return disclaimer.data || "";
  }

  return `<p>${disclaimer}</p>`;// old string returned as a paragraph
};

export {
  getDisclaimerHtml
}